export default {
    admin: {
        title: "Dashboard",
        subtitle: "Panoramica del sistema e gestione accounts",
        newAccount: "Nuovo Account",
        loading: "Caricamento dashboard...",
        stats: {
            totalAccounts: "Totale Accounts",
            activeAccounts: "Accounts Attivi",
            newThisMonth: "Nuovi Questo Mese",
            suspendedAccounts: "Accounts Sospesi",
        },
        recentAccounts: {
            title: "Accounts Recenti",
            description: "Ultimi 5 accounts creati nel sistema",
            viewAll: "Vedi tutti",
            headers: {
                userType: "User Type",
                legalName: "Nome Legale",
                entityType: "Tipo Entità",
                country: "Paese",
                status: "Stato",
                createdAt: "Data Creazione",
            },
            status: {
                active: "Attivo",
                suspended: "Sospeso",
                inactive: "Inattivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Container ID",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Container ID",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Panoramica dei container ricevuti e collaborazioni",
        loading: "Caricamento dashboard...",
        newOrderRequest: "Richiesta Nuovo Ordine",
        manageShippers: "Gestisci Spedizionieri",
        viewContainers: "Vedi Container",
        newOrderModal: {
            title: "Nuova Richiesta Ordine",
            shipper: "Spedizioniere",
            shipperPlaceholder: "Seleziona un spedizioniere",
            targetWeek: "Settimana Target",
            packingList: "Packing List Richiesta",
            packingListPlaceholder: "Descrivi in dettaglio la packing list richiesta...",
            notes: "Note",
            notesPlaceholder: "Note aggiuntive sull'ordine...",
            submit: "Crea Ordine"
        },
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container ricevuti",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Container ID",
                shipper: "Spedizioniere",
                route: "Route",
                progress: "Progress",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
            },
        },
        monthlyTrend: {
            title: "Andamento Mensile",
        },
        trendVsLastMonth: "vs mese scorso",
        receivedContainers: "Container Ricevuti",
        activeShippers: "Spedizionieri Attivi",
        charts: {
            commodityDistribution: "Distribuzione Commodity",
            originCountries: "Paesi di Origine",
            arrivalPorts: "Porti di Arrivo",
        },
    },
};
